import { type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { allowedProductStatuses } from './constants';

export function isAllowedProductVariantStatus(status: unknown): status is OpenApiSchemaProductVariant['status'] {
    return typeof status === 'string' && status in allowedProductStatuses;
}
